import * as XLSX from "xlsx";

export const prepareExcelData = (list, columns) => {
  return list.map((row, index) => {
    const obj = {};

    columns.forEach(col => {

      // S.No
      if (col.key === "sn") {
        obj[col.header] = index + 1;
        return;
      }

      // Derived / lookup values
      if (typeof col.value === "function") {
        obj[col.header] = col.value(row) || "";
        return;
      }

      // Date formatting
      if (col.type === "date") {
        obj[col.header] = row[col.key]
          ? new Date(row[col.key]).toLocaleDateString("en-IN")
          : "";
        return;
      }

      // Currency / number
      if (col.type === "currency") {
        obj[col.header] = row[col.key]
          ? Number(row[col.key]).toLocaleString("en-IN")
          : "";
        return;
      }

      // Default
      obj[col.header] = row[col.key] ?? "";
    });

    return obj;
  });
};

export function autoFitColumns(ws) {
  if (!ws || !ws["!ref"]) return;

  const range = XLSX.utils.decode_range(ws["!ref"]);
  const colWidths = [];

  for (let C = range.s.c; C <= range.e.c; C++) {
    let maxLength = 10; // minimum width

    for (let R = range.s.r + 2; R <= range.e.r; R++) { // skip first 2 rows
      const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
      const cell = ws[cellAddress];

      if (!cell || cell.v == null) continue;

      const cellValue = cell.v.toString();
      maxLength = Math.max(maxLength, cellValue.length);
    }

    colWidths[C] = { wch: Math.min(maxLength + 2, 30) };
  }

  ws["!cols"] = colWidths;
}

